<template>
    <div class="body">
        <div class="content">
            <div class="c_top">
                <div class="ct_left">个人信息</div>
                <img class="ct_right" :src="webImg + info.avatar" />
            </div>
            <div class="c_center" v-if="info && info.phone">
                <div class="cc_item">
                    <div>姓名</div>
                    <div>{{ info.nickName }}</div>
                </div>
                <div class="cc_item">
                    <div>手机号</div>
                    <div>{{ info.phone }}</div>
                </div>
                <div class="cc_item">
                    <div>任教学段</div>
                    <div>{{ info.techSection }}</div>
                </div>
                <div class="cc_item">
                    <div>当前职务</div>
                    <div>{{ info.techPost }}</div>
                </div>
                <div class="cc_item" v-if="info.sectionVal">
                    <div>任教科目</div>
                    <div>{{ info.sectionVal }}</div>
                </div>
                <div class="cc_item">
                    <div>所在学校</div>
                    <div>{{ info.techSchool }}</div>
                </div>
                <div class="cc_item" v-if="info.address">
                    <div>地区</div>
                    <div>{{ info.address }}</div>
                </div>
            </div>
            <div class="c_bottom" @click="$router.go(-1)">返回</div>
        </div>
    </div>
</template>

<script>
import { userInfo, areaCascaderList, techPostListBySectionId,sectionSubject } from '@/apis/index'
export default {
    data() {
        return {
            info: {},
        }
    },
    mounted() {
        this.getUserInfo()
    },
    methods: {
        //学段 科目
        getSectionAndSubjectList() {
            sectionSubject(2).then(res => {
                console.log(res, 'getSectionAndSubjectList');
                var sectionList = res.data.filter((item, index) => {
                    return item.subjectList.length > 0
                })
                var sectionItem = sectionList.filter(item => {
                    return item.id == this.info.techSectionId
                })[0]
                var sectionIndex = sectionList.findIndex((item) => item.id == this.info
                    .techSectionId)
                var subjectIndex = sectionItem.subjectList.findIndex((item) => item.id == this.info
                    .techSubjectId)
                var subjectList = sectionItem.subjectList
                this.info.sectionVal = subjectList[subjectIndex].name
                this.$forceUpdate()
                // this.getJobList()
            })
        },
        getJobList() {
            techPostListBySectionId(this.info.techSectionId).then(res => {
                console.log(res, 'techPostListBySectionId');
                res.data.forEach(e => {
                    e.select = 0
                })
                var techPosts = []
                res.data.forEach(itemA => {
                    this.info.techPostList.forEach(itemB => {
                        if (itemA.techPost == itemB.techPost) {
                            techPosts.push(itemA.techPost)
                        }
                    })
                })
                this.info.techPost = techPosts.join(' ')
            })
        },
        getAddressList() {
            areaCascaderList().then(res => {
                console.log(res, 'areaCascaderList');
                var ids = this.info.addrInfo.split(',')
                var province = res.data.filter(item => {
                    return item.value == ids[0]
                })[0]
                if (province) {
                    var city = province.children.filter(item => {
                        return item.value == ids[1]
                    })[0]
                    if (city) {
                        var district = city.children.filter(item => {
                            return item.value == ids[2]
                        })[0]
                        console.log(province, city, district);

                        this.info.address = province.label + ' ' + city.label + ' ' + district.label
                    }
                }
                this.$forceUpdate();
            })
        },
        getUserInfo() {
            userInfo().then(res => {
                console.log(res, 'userInfo')
                this.info = res.data
                this.getAddressList()
                this.getJobList()
                this.getSectionAndSubjectList()
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.body {
    width: 1200px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .content {
        width: 100%;
        height: 580px;
        background: #FFFFFF;
        border-radius: 26px;
        box-sizing: border-box;
        padding: 40px 80px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .c_top {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .ct_left {
                font-weight: bold;
                font-size: 30px;
                color: #252525;
            }

            .ct_right {
                width: 72px;
                height: 72px;
                border-radius: 6px;
            }
        }

        .c_center {
            width: 100%;

            .cc_item {
                width: 100%;
                display: flex;
                align-items: center;
                margin-top: 30px;

                div:nth-child(1) {
                    width: 100px;
                    font-weight: 500;
                    font-size: 16px;
                    color: #666666;
                    margin-right: 8px;
                }

                div:nth-child(2) {
                    font-weight: bold;
                    font-size: 16px;
                    color: #252525;
                }
            }
        }

        .c_bottom {
            width: 200px;
            height: 52px;
            background: #2992FF;
            border-radius: 8px 8px 8px 8px;
            font-weight: bold;
            font-size: 20px;
            color: #FFFFFF;
            text-align: center;
            line-height: 52px;
            margin-top: 30px;
            cursor: pointer;
        }
    }
}
</style>